import React from "react";
import {
  useAdminDashboardEnabled,
  useInternalAffairsEnabled,
} from "@/pages/StationAdmin/featureFlag";
import NotFound404 from "@/pages/NotFound";

/**
 * Route guard for the Station Admin AREA. The area is reachable when EITHER
 * per-station WorkOS flag is on: `admin-dashboard` (the Overview dashboard) or
 * `internal-affairs` (the IA tab). Only when BOTH are off does a station get
 * the 404 — so enabling just `internal-affairs` no longer 404s the whole area.
 *
 * The individual destinations stay gated on their own flag: the Overview index
 * (StationAdminIndex) requires `admin-dashboard` and otherwise redirects to the
 * IA tab, and the IA route is wrapped in RequireInternalAffairs. Composes with
 * — does not replace — the station_admin RequireRole check nested inside.
 *
 * Deliberately a guard rather than a conditional `<Route>`: WorkOS flags aren't
 * populated until the session finishes restoring, so keeping the path always
 * registered resolves the URL to the loading spinner during restore rather than
 * flashing the catch-all 404 (same pattern as RequireIncidentManagement).
 */
export function RequireStationAdminArea({
  children,
}: {
  children: React.ReactNode;
}) {
  const dashboardEnabled = useAdminDashboardEnabled();
  const iaEnabled = useInternalAffairsEnabled();
  if (!dashboardEnabled && !iaEnabled) return <NotFound404 />;
  return <>{children}</>;
}
